import script from "./GlobalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalModal.vue?vue&type=script&setup=true&lang=js"

import "./GlobalModal.vue?vue&type=style&index=0&id=6977f928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6977f928"]])

export default __exports__